module.exports = "/_next/static/images/cb679e81da2e56b02b75bc851670c0fc-footer-fogafin-cucuta-4x.png.webp";